// icon-data/registry.ts — assembles the front-end-owned icon catalogs into ONE lookup.
//
// The catalog modules are loaded IN ORDER and merged with the EXACT precedence the old PHP
// build_js_icon_lookup() used, so the result is byte-identical to the legacy window.ICON_LOOKUP:
//   1) StaticHelp, 2) SpecialIcon, 3) NamedIcon (shared catalogs), 4) CustomNamedIcon  — later WINS,
//   5) SimpleCustomIcon — only fills keys NOT already present (the old `if (!isset($lookup[$name]))`),
//   6) help-circle-outline default, 7) FE overrides — these WIN over everything.

import type { IconMap } from './types';
import { STATIC_HELP_ICONS } from './catalogs/static-help';
import { SPECIAL_ICONS } from './catalogs/special-icons';
import { SHARED_CATALOG_ICONS } from './catalogs/shared-catalog-icons.generated';
import { CUSTOM_NAMED_ICONS } from './catalogs/custom-named-icons';
import { SIMPLE_ICONS } from './catalogs/simple-icons';
import { ICON_OVERRIDES } from './overrides';

function buildRegistry(): IconMap {
    const reg: IconMap = {};
    // 1–4: later source overwrites earlier (mirrors the PHP $add overwrite for these four).
    Object.assign(reg, STATIC_HELP_ICONS, SPECIAL_ICONS, SHARED_CATALOG_ICONS, CUSTOM_NAMED_ICONS);
    // 5: SimpleCustomIcon fills gaps only.
    for (const key of Object.keys(SIMPLE_ICONS)) {
        const icon = SIMPLE_ICONS[key];
        if (icon && !(key in reg)) reg[key] = icon;
    }
    // 6: default fallback entry.
    reg['help-circle-outline'] = { file: 'help-circle-outline', tooltip: 'Unknown' };
    // 7: front-end-only overrides win.
    Object.assign(reg, ICON_OVERRIDES);
    return reg;
}

export const ICON_REGISTRY: IconMap = buildRegistry();
